export default "__VITE_ASSET__DkN_4gAK__"